import { render, staticRenderFns } from "./AppPhoneNumberInput.vue?vue&type=template&id=6146b4bd&scoped=true"
import script from "./AppPhoneNumberInput.vue?vue&type=script&lang=js"
export * from "./AppPhoneNumberInput.vue?vue&type=script&lang=js"
import style0 from "./AppPhoneNumberInput.vue?vue&type=style&index=0&id=6146b4bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6146b4bd",
  null
  
)

export default component.exports